// extracted by mini-css-extract-plugin
export default {"RemovedIngredients":"RemovedIngredients_RemovedIngredients__2vxLF"};